var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-button', {
    attrs: {
      "size": "xl",
      "variant": "primary"
    },
    on: {
      "click": _vm.downloadPdf
    }
  }, [_vm._v(" Download en print PDF ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }